import { getHubConfig } from './getHubConfig';
import { postAuthInfoUpload } from './postAuthInfoUpload';
import { getHubTenantsList } from './getHubTenantsList';
import { getHubTenantHubConfig } from './getHubTenantHubConfig';
import { postClientHubConfig } from './postClientHubConfig';
import { deleteClientHubConfig } from './deleteClientHubConfig';

export default {
  getHubConfig,
  postAuthInfoUpload,
  getHubTenantsList,
  getHubTenantHubConfig,
  postClientHubConfig,
  deleteClientHubConfig
};
